import React from 'react';

import {UserAvatar} from 'app/components/general/avatars';
import {FullHTMLLink} from 'app/components/general/FullHTMLLink';
import ThreeDotsDropdownMenu from 'app/general/widgets/ThreeDotsDropdownMenu';
import {StyledDocItem} from 'app/procedures/styles';
import {getMembership} from 'app/teams/utils';
import {gt} from 'app/utils/i18n';

import type {actionsGetterType} from 'app/general/widgets/ThreeDotsDropdownMenu';
import type {TeamSerializedType, UserSerializedType} from 'sweet-types';

interface Props {
  team: TeamSerializedType;
  object: UserSerializedType;
  actionsGetter: actionsGetterType<UserSerializedType>;
}

export function TeamRolesUserListItem({
  object: user,
  team,
  actionsGetter,
}: Props): JSX.Element {
  const membership = getMembership(user, team);

  return (
    <StyledDocItem className="row no-gutters border-bottom">
      <div className="col col-lg d-flex align-items-center">
        <UserAvatar
          small={true}
          className="mr-2"
          user={user}
          tooltipPlacement={'right'}
          showCard
        />
        <FullHTMLLink
          html_url={user.html_url}
          title={user.email}
          className="text-dark font-weight-bold small"
        >
          {user.name || user.email || gt('Unnamed Person')}
        </FullHTMLLink>
      </div>
      <div className="col-auto d-flex align-items-center">
        {user.is_super_manager ? (
          <span className="ml-3 badge badge-light">{gt('Super Manager')}</span>
        ) : null}

        {membership?.access == 'manager' ? (
          <span className="ml-3 badge badge-light">{gt('Manager')}</span>
        ) : membership?.access == 'reader' ? (
          <span className="ml-3 badge badge-light">{gt('Read Only')}</span>
        ) : null}
      </div>
      <div className="col-auto d-flex align-items-center">
        <div className="p-2 small">
          <ThreeDotsDropdownMenu
            className="btn-sm"
            actionsGetter={actionsGetter}
            object={user}
            alwaysUseSpace={true}
          />
        </div>
      </div>
    </StyledDocItem>
  );
}
